const getPlainText = (htmlText = ''): string =>
  htmlText
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&ZeroWidthSpace;/g, '');

export default getPlainText;
